import React, { useState, useEffect } from 'react';
import { functions } from '../firebaseConfig'; // Import your Firebase config
import { httpsCallable } from 'firebase/functions';
import './PostcodeSearch.scss';

// Search to addresses based on postcode from Ordinance Survey API

const PostcodeSearch = ({
  onPostcodeChange,
  onSelectAddress,
  postcode,
  errors, // Receive errors prop for styling
}) => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownEnabled, setDropdownEnabled] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(''); // Store selected address

  const validatePostcode = (postcode) => {
    const postcodeRegex = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;
    return postcodeRegex.test(postcode.trim());
  };

  useEffect(() => {
    if (validatePostcode(postcode)) {
      fetchAddresses(postcode);
    } else {
      setDropdownEnabled(false);
      setAddresses([]);
    }
  }, [postcode]);

  const handlePostcodeInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    onPostcodeChange(value);
    setSelectedAddress(''); // Reset selected address when postcode changes
  };

  // Using Firebase Cloud Functions to fetch addresses
  const fetchAddresses = async (postcode) => {
    setLoading(true);
    try {
      const fetchAddressFunction = httpsCallable(functions, 'fetchAddresses'); // Firebase function
      const result = await fetchAddressFunction({ postcode });
      console.log('Addresses:', result);
      setAddresses(result.data.addresses || []);
      setDropdownEnabled(true);
    } catch (err) {
      console.error('Failed to fetch addresses:', err);
      setDropdownEnabled(false);
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSelect = (e) => {
    const value = e.target.value;
    if (value) {
      const address = JSON.parse(value);
      setSelectedAddress(value); // Set the selected value as the full JSON string
      onSelectAddress(address.DPA.ADDRESS); // Pass only the address text to parent
    } else {
      onSelectAddress(''); // Clear address if no selection
      setSelectedAddress('');
    }
  };

  return (
    <div className="postcode-search-component">
      {/* Postcode Input */}
      <input
        type="text"
        placeholder="Enter postcode"
        value={postcode}
        onChange={handlePostcodeInputChange}
        className={`postcode-search-input ${
          errors && errors.postcode ? 'error-border' : ''
        }`}
      />

      {/* Loading Indicator */}
      {loading && (
        <p className="postcode-search-loading">Loading addresses...</p>
      )}

      {/* Address Dropdown */}
      <select
        onChange={handleAddressSelect}
        disabled={!dropdownEnabled}
        className={`postcode-search-dropdown ${
          !selectedAddress && errors && errors.address ? 'error-border' : ''
        }`}
        value={selectedAddress} // Set to full JSON string of selected address
      >
        <option value="">Select an address</option>
        {addresses.map((address, index) => (
          <option key={index} value={JSON.stringify(address)}>
            {address.DPA.ADDRESS}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PostcodeSearch;
